

import { useEffect } from 'react';


import { tabController } from '../../bpl-tools/utils/functions';

import Settings from './Settings';
import Style from './Style';
import ProtectContent from './ProtectContent';

const Edit = props => {
	const { className, attributes, setAttributes, clientId, isSelected } = props;

	useEffect(() => { clientId && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]); // Set & Update clientId to cId

	useEffect(() => tabController(), [isSelected]);

	return <>
		<Settings attributes={attributes} setAttributes={setAttributes} />

		<div className={className} id={`eebEmailEncode-${clientId}`}>
			<Style attributes={attributes} clientId={clientId} />

			<div className="eebEmailEncode">
				<ProtectContent attributes={attributes} clientId={clientId} />
			</div>
		</div>
	</>;
};
export default Edit;